export default __webpack_public_path__ + "static/media/start-a-business.4002fef8.svg";